/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.demo-request', []);
